import type { Agency } from '@saaga/shared/interfaces/agencies.interface'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface AgencyDetailStartChatButtonProps {
  agency: Agency
  onStartChat?: (agency: Agency) => void
}

export const AgencyDetailStartChatButton = ({
  agency,
  onStartChat,
}: AgencyDetailStartChatButtonProps): ReactNode => {
  if (!onStartChat) return null

  return (
    <Button
      variant="secondary"
      size="sm"
      className="agency-detail-start-chat bg-zinc-800 text-white hover:bg-zinc-700 dark:bg-zinc-200 dark:text-zinc-900 dark:hover:bg-zinc-300"
      onClick={() => onStartChat(agency)}
    >
      Start Chat
    </Button>
  )
}

AgencyDetailStartChatButton.displayName = 'AgencyDetailStartChatButton'
